/// THIS FILE IS AUTOGENERATED!!! DO NOT EDIT MANUALLY!!!
/// INSTEAD, USE A VITE PLUGIN OR RUN `php artisan bridge:generate:enumerations` COMMAND.

export const Unit = {
  Kilometer: 'KILOMETER',
  Centimeter: 'CENTIMETER',
  Meter: 'METER',
  Millimeter: 'MILIMETER',
  LinearMeter: 'LINEAR_METER',
  Ton: 'TON',
  Kilogram: 'KILOGRAM',
  Decagram: 'DEKAGRAM',
  Gram: 'GRAM',
  Milligram: 'MILIGRAM',
  MeterSquared: 'METER_SQUARED',
  Are: 'ARE',
  Hectare: 'HECTARE',
  CubicMeter: 'METER_CUBED',
  Liter: 'LITRE',
  Milliliter: 'MILILITRE',
  Month: 'MONTH',
  Week: 'WEEK',
  Day: 'DAY',
  Hour: 'HOUR',
  Minute: 'MINUTE',
  Piece: 'PIECE',
  Package: 'PACKAGE',
  Set: 'SET',
  Foot: 'FOOT',
  Inch: 'INCH',
  USGallon: 'US_GALLON',
  USPint: 'US_PINT',
  UKGallon: 'UK_GALLON',
  UKPint: 'UK_PINT',
  Pound: 'POUND',
  Ounce: 'OUNCE',
} as const;

export type Unit = typeof Unit[keyof typeof Unit];
